import { Group, MantineTheme } from "@mantine/core";
import { IconSquareCheckFilled, IconSquareXFilled } from "@tabler/icons-react";
import { ReactNode } from "react";

export function TiendasVisitasPersonalViewColumnsOverrides(theme: MantineTheme) {
    return {
        7: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val === '0') {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconSquareXFilled style={{ color: theme.colors.red[8], minWidth: "1.3rem" }} size="1.3rem" />
                    </Group>
                } else if (val === '1') {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconSquareCheckFilled style={{ color: theme.colors.green[8], minWidth: "1.3rem" }} size="1.3rem" />
                    </Group>
                }
                return value as ReactNode;
            }
        },
        9: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val === '0') {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconSquareXFilled style={{ color: theme.colors.red[8], minWidth: "1.3rem" }} size="1.3rem" />
                    </Group>
                } else if (val === '1') {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconSquareCheckFilled style={{ color: theme.colors.green[8], minWidth: "1.3rem" }} size="1.3rem" />
                    </Group>
                }
                return value as ReactNode;
            }
        },
    }
}